import './ApiBlockInput.css';
import TextInput from '/src/components/UI/TextField/TextInput';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import { useState } from 'react';
// <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" />
function ApiBlockInput ({KeyValue, value, deleteValue, idx, setValue}) {

    // State to keep in memory the values
    const [keyRow, setKeyRow] = useState(KeyValue ? KeyValue : '');
    const [valueRow, setValueRow] = useState(value ? value : '');

    return (
        <div className='form_sub_block'>
            <TextInput className="editor-input-sub" placeholder="key" value={keyRow} onChange={(e) => setKeyRow(e.target.value)} onBlur={() => setValue(idx, 'key', keyRow)}/>
            <TextInput className="editor-input-sub" placeholder="value" value={valueRow} onChange={(e) => setValueRow(e.target.value)} onBlur={() => setValue(idx, 'value', valueRow)}/>
            <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" onClick={() => deleteValue(idx)}/>
        </div>

    )
}

export default ApiBlockInput;